<template>
  <div class="card-form">
    <PageMain
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @openEditPage="openEditPage"
      @checkbox-change="(r) => (checkRows = r)"
      @printer="({ fabricCode }) => labelPrint(fabricCode)"
    >
      <PageHeader
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
      >
        <template>
          <!-- <b-button
            v-if="allow('A')"
            size="sm"
            class="ml-2"
            variant="outline-success"
            @click="openEditPage({ pageType: 'add' })"
          >
            <b-icon-plus></b-icon-plus>
            {{ $l('INDEX.btn_add') || '新增' }}
          </b-button> -->
        </template>
      </PageHeader>
      <pagination
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageMain>
  </div>
</template>
<script>
import PageHeader from './header.vue'
import PageMain from './main.vue'
import BaseTable from '@/mixins/base-table'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [BaseTable, EditLoading],
  components: { PageHeader, PageMain },
  data() {
    return {
      usePage: true,
      checkRows: [],
    }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .masterFabricEcomList({ ...form, ...this.page })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditPage({ pageType, params = {}, query = {} }) {
      this.$router.push({
        name: 'ecom-awsSample-fabric-detail',
        params: { ...params, pageType },
        query,
      })
    },
  },
}
</script>
